function Error404Description({ className, error404Title, error404Info }) {
  return (
    <div className={`error-info ${className || ''}`}>
      <h1 className="highlight">{error404Title}</h1>
      <h3 className="fw-bold">{error404Info}</h3>
    </div>
  );
}

export default Error404Description;
